export const CLUB_ATTRS = {
  context: 'data-club-context-props',
  switcher: 'data-club-lpu-price-switcher',
  priceLink: 'data-club-lpu-price-link',
}
